import React from 'react';
import Layout from '../../components/Layout';
import '../../Styles/Landing.scss';
import phoneImage from '../../assets/webp_images/hand_phone_hero.webp';
import monitorImage from '../../assets/webp_images/monitor_hero.webp';
import circles1 from '../../assets/icons/circles1.svg';
import circles2 from '../../assets/icons/circle2.svg';
import testimonials from '../../assets/webp_images/testimonials_photo.webp';
import quoteTop from '../../assets/icons/quote_top.svg';
import quoteBottom from '../../assets/icons/quote_bottom.svg';
// import Newsletter from "../../components/Newsletter/Newsletter";
import { Link } from 'react-router-dom';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Helmet } from 'react-helmet';
import petapixel from '../../assets/icons/petapixel.svg';

const Landing = () => {
  return (
    <Layout>
      <div className="bgColor">
        <Helmet>
          <title>TruHu - Monitor Color Calibration Tool | Good Color Made Easy</title>
          <meta
            name="description"
            content="​​Calibrate your displays in under a minute with the TruHu App. Account for ambient lighting and Achieve color accuracy using just your phone's camera!"
          />
        </Helmet>
        <div className="first-section__landing">
          <div className="first-section-text__landing">
            <div>
              <h1 style={{ marginBottom: '32px' }}>Monitor Color Calibration Tool</h1>
              <h2>
                Good color
                <br /> made easy
              </h2>
            </div>
            <p>
              Achieve professional color accuracy with TruHu’s
              <br />
              app-based calibration tool in a few simple steps.
            </p>
            <Link to="/product">
              <button>Get started</button>
            </Link>
            <img src={circles2} alt="" className="circles2" />
          </div>
          <div className="gradient__landing">
            <img src={circles1} alt="" className="circles1" />
            <img src={phoneImage} alt="" className="phone" />
            <img src={monitorImage} alt="" className="monitor" />
          </div>
        </div>
        <div className="second-section__landing">
          <div className="withoutTruhu"></div>
          <div className="second-section-text__landing">
            <h2>Bring color truth to your screens and projects!</h2>
            <p>
              Your photography, illustrations, designs, and videos
              <br /> all come to life in vibrant colors with TruHu.
            </p>
            <Link to="/product">
              <button>Get started</button>
            </Link>
          </div>
          <div className="withTruhu"></div>
        </div>
        <div className="third-section__landing">
          <img src={testimonials} alt="" className="testimonialsImg" />
          <div className="testimonials">
            <div className="testimonialsContent">
              <img src={quoteTop} alt="" className="quote-top" />
              <Carousel showThumbs={false} infiniteLoop interval={5000} autoPlay={true}>
                <div style={{ textAlign: 'center', margin: 'auto' }}>
                  <div>
                    <p>
                      I got similar results [to colorimeters] in a fraction of the time, at a
                      fraction of the cost, and using just my phone. TruHu is the perfect gateway to
                      a better and more consistent color. For many users, it’s the last calibration
                      technology they’ll need
                    </p>
                    <div className="author">
                      <img src={petapixel} alt="petapixel" />
                      <p>
                        <a
                          href="https://petapixel.com/2023/06/06/truhu-review-a-simple-way-to-calibrate-monitors-with-a-smartphone/"
                          target="blank">
                          PetaPixel - TruHu Review
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div style={{ textAlign: 'center', margin: 'auto' }}>
                  <div>
                    <p>
                      ‘I work with artists, who are naturally sticklers for the most accurate color
                      in reproductions. TruHu is an excellent addition to my arsenal that helps me
                      to guarantee the exacting color my artist collaborators require.’
                    </p>
                    <div className="author">
                      <p className="author-name">Ryan Graff</p>
                      <p>
                        Fine Art Printer and Publisher{' '}
                        <a href="https://www.ryangraff.art" target="blank">
                          www.ryangraff.art
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </Carousel>
              <img src={quoteBottom} alt="" className="quote-bottom" />
            </div>
          </div>
        </div>
        {/* <Newsletter /> */}
      </div>
    </Layout>
  );
};

export default Landing;
